import React, { useState, useEffect } from "react";
import { GoiLogo, NextLink, Spacing, VStack } from "../components";
import { customEvent } from "../utils";
import { GOI_AUDIT_REPORT_URL, GOI_COMPANY_ADDRESS } from "../constants";

export default function Footer() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 767);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const containerStyles: React.CSSProperties = {
    padding: isMobile ? "0px 24px" : "0px 40px",
  };

  const linkContainerStyles: React.CSSProperties = {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
  };

  const linkStyles: React.CSSProperties = {
    marginBottom: isMobile ? "3px" : "0px",
  };

  const infoContainerStyles: React.CSSProperties = {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
  };

  const copyrightStyles: React.CSSProperties = {
    width: isMobile ? "240px" : "100%",
    wordBreak: "keep-all" as const,
    whiteSpace: isMobile ? "pre-line" : "normal",
  };

  const createLinkWithSeparator = (
    content: React.ReactNode,
    isLast = false
  ) => {
    return (
      <span style={linkStyles}>
        {content}
        {!isMobile && !isLast && <span style={{ margin: "0px 6px" }}>|</span>}
      </span>
    );
  };

  const createInfoWithSeparator = (
    content: React.ReactNode,
    isLast = false
  ) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span>{content}</span>
      {!isMobile && !isLast && <span style={{ margin: "0px 6px" }}>|</span>}
    </div>
  );

  return (
    <VStack
      width="100%"
      background="#423a39"
      padding="60px 0px 180px"
      alignItems="center"
      className="caption1 white"
    >
      <VStack maxWidth={`${1200}px`} width="100%" padding="0px 24px">
        <GoiLogo color="white" size={36} />
        <Spacing gap={14} />
        <div>(주)고이장례연구소</div>
        <Spacing gap={8} />
        <div style={linkContainerStyles} className="gray300">
          {createLinkWithSeparator(
            <a href="https://goifuneral.notion.site/49549cb0c8b044a7a9605b8cfe251ce3">
              이용약관
            </a>
          )}

          {createLinkWithSeparator(
            <a
              href="https://goifuneral.notion.site/544becd151c946618d151bd9b2659414"
              className="font-700 orange650"
            >
              개인정보처리방침
            </a>
          )}

          {createLinkWithSeparator(
            <a href="https://goifuneral.notion.site/90469f8dfa42468bbc5b44d4b63675e9">
              중요정보 고시사항
            </a>
          )}

          {createLinkWithSeparator(
            <a
              href={GOI_AUDIT_REPORT_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                customEvent({
                  domain: "common",
                  path: "footer",
                  trigger_and_target: "report",
                });
              }}
            >
              감사보고서
            </a>
          )}

          {createLinkWithSeparator(
            <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8318701971">
              사업자정보확인
            </a>
          )}

          {createLinkWithSeparator(
            <a
              href="tel:1666-9784"
              onClick={() => {
                customEvent({
                  domain: "common",
                  path: "footer",
                  trigger_and_target: "cs_center-uv_my",
                });
              }}
            >
              고객센터
            </a>
          )}

          {createLinkWithSeparator(
            <a
              href="https://www.goifuneral.co.kr/consultant/search/"
              onClick={() => {
                customEvent({
                  domain: "common",
                  path: "footer",
                  trigger_and_target: "footer-uv_consultant-search",
                });
              }}
            >
              상담사 조회
            </a>,
            true
          )}
        </div>

        <Spacing gap={28} />
        <div className="gray500">
          <div style={infoContainerStyles}>
            {createInfoWithSeparator("대표이사 : 송슬옹")}
            <div>개인정보관리책임자 : 김소현</div>
          </div>
          <div>사업자 등록번호 : 831-87-01971</div>
          <div>통신판매업신고번호 : 2021-서울관악-2417</div>
          <div>전화권유판매업신고번호: 2024-서울관악-0001</div>
          <div>선불식할부거래업등록번호: 서울-2024-제174호</div>
          <div style={infoContainerStyles}>
            {createInfoWithSeparator("Tel : 1666-9784")}
            <div>주소 : {GOI_COMPANY_ADDRESS}</div>
          </div>
          <div style={infoContainerStyles}>
            <div>이메일 : contact@goifuneral.co.kr</div>
          </div>
        </div>
        <Spacing gap={12} />
        <div style={copyrightStyles}>
          <Spacing gap={32} />
          <div>
            © {new Date().getFullYear()}. (주)고이장례연구소 ALL RIGHTS
            RESERVED.
          </div>
        </div>
        <Spacing gap={20} />
      </VStack>
    </VStack>
  );
}
